import { useContext } from 'react';

import { OverlayContainerContext } from './OverlayContainerContext';

export const useOverlayContainerContext = () => {
  return useContext(OverlayContainerContext);
};
